<template>
  <section class="produccion-page">
    <b-card class="filters-card">
      <b-row class="g-1">
        <b-col cols="12" lg="4">
          <label class="filter-label">Establecimiento</label>
          <v-select
            v-model="filters.establecimiento"
            :options="establecimientos"
            label="text"
            placeholder="Todos"
            :reduce="(option) => option"
          />
        </b-col>
        <b-col cols="12" lg="4">
          <label class="filter-label">Fecha</label>
          <flat-pickr
            v-model="filters.fecha"
            placeholder="DD/MM/AAAA"
            :config="configdateTimePicker"
            class="form-control"
          />
        </b-col>
        <b-col cols="12" lg="4">
          <label class="filter-label">Especialidad</label>
          <v-select
            v-model="filters.especialidad"
            :options="opsespecialidad"
            label="text"
            placeholder="Todos"
            :reduce="(option) => option"
          />
        </b-col>
      </b-row>
      <b-row class="g-1 mt-1">
        <b-col cols="12" lg="4" class="ml-auto d-flex align-items-end gap-1">
          <b-button variant="primary" class="w-100" @click="onBuscar">
            Buscar
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-row v-if="showResults" class="mt-2">
      <b-col cols="12" lg="8">
        <b-card class="panel-card">
          <h5 class="panel-title">Tendencia de Producción</h5>
          <div class="chart-wrap">
            <LineChart
              :chart-data="trendChartData"
              :chart-options="trendChartOptions"
              :chart-id="'kpi-trend-chart'"
            />
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" lg="4">
        <b-card class="panel-card mb-1">
          <h5 class="panel-title">Producción por Especialidad</h5>
          <b-table
            small
            responsive
            :items="especialidadRows"
            :fields="especialidadFields"
            class="mb-0"
          />
        </b-card>
        <b-card class="panel-card">
          <h5 class="panel-title">Producción por Establecimiento</h5>
          <b-table
            small
            responsive
            :items="establecimientoRows"
            :fields="establecimientoFields"
            class="mb-0"
          />
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import vSelect from "vue-select";
import { Line } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "KpiProduccion",
  components: {
    vSelect,
    flatPickr,
    LineChart: Line,
  },
  data() {
    return {
      filters: {
        establecimiento: { value: "all", text: "Todos" },
        fecha: null,
        especialidad: { value: "all", text: "Todos" },
      },
      establecimientos: [{ value: "all", text: "Todos" }],
      opsespecialidad: [{ value: "all", text: "Todos" }],
      showResults: false,
      trendSeries: [
        { name: "Servicios", data: [180, 240, 320, 290, 410, 520] },
        { name: "Ingresos", data: [140, 210, 300, 260, 380, 460] },
      ],
      trendLabels: ["Ene", "Feb", "Mar", "Abr", "May", "Jun"],
      especialidadRows: [
        { especialidad: "Consultas Médicas", servicios: 320, ingresos: "$92,000" },
        { especialidad: "Pediatría", servicios: 200, ingresos: "$52,000" },
        { especialidad: "Imagenología", servicios: 180, ingresos: "$64,000" },
        { especialidad: "Rehabilitación Física", servicios: 150, ingresos: "$32,000" },
      ],
      establecimientoRows: [],
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "d/m/Y",
        locale: Spanish,
      },
    };
  },
  computed: {
    trendChartData() {
      return {
        labels: this.trendLabels,
        datasets: this.trendSeries.map((serie, index) => ({
          label: serie.name,
          data: serie.data,
          borderColor: this.pickColor(index),
          backgroundColor: "transparent",
          borderWidth: 2,
          pointRadius: 3,
          pointHoverRadius: 5,
          tension: 0.25,
        })),
      };
    },
    trendChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: "bottom" },
          title: { display: false },
        },
        scales: {
          x: { ticks: { color: "#5A6B82" } },
          y: { ticks: { color: "#5A6B82" } },
        },
      };
    },
    especialidadFields() {
      return [
        { key: "especialidad", label: "Especialidad" },
        { key: "servicios", label: "Servicios" },
        { key: "ingresos", label: "Ingresos" },
      ];
    },
    establecimientoFields() {
      return [
        { key: "establecimiento", label: "Establecimiento" },
        { key: "servicios", label: "Servicios" },
        { key: "ingresos", label: "Ingresos" },
      ];
    },
  },
  mounted() {
    this.fetchEstablecimientos();
    this.fetchEspecialidades();
  },
  methods: {
    onBuscar() {
      this.showResults = true;
    },
    pickColor(index) {
      const palette = ["#4C78A8", "#54A24B", "#F58518", "#E45756"];
      return palette[index % palette.length];
    },
    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        const rows = response?.data?.data?.allEstablecimientos || [];
        this.establecimientos = [
          { value: "all", text: "Todos" },
          ...rows.map((item) => ({
            value: item.id,
            text: item.Descripcion,
            uniCodigo: item.uniCodigo,
          })),
        ];
        this.updateEstablecimientoRows();
      } catch (error) {
        this.establecimientos = [{ value: "all", text: "Todos" }];
        this.updateEstablecimientoRows();
      }
    },
    async fetchEspecialidades() {
      const query = `
        query {
          allEspecialidad {
            id
            descripcion
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        const rows = response?.data?.data?.allEspecialidad || [];
        this.opsespecialidad = [
          { value: "all", text: "Todos" },
          ...rows.map((item) => ({
            value: item.id,
            text: item.descripcion,
          })),
        ];
      } catch (error) {
        this.opsespecialidad = [{ value: "all", text: "Todos" }];
      }
    },
    updateEstablecimientoRows() {
      const names = this.establecimientos
        .filter((item) => item.value !== "all")
        .slice(0, 3)
        .map((item) => item.text);

      if (!names.length) {
        this.establecimientoRows = [];
        return;
      }

      const base = [420, 250, 180];
      this.establecimientoRows = names.map((name, index) => ({
        establecimiento: name,
        servicios: base[index] || 120,
        ingresos: `$${(base[index] || 120) * 260}`,
      }));
    },
  },
};
</script>

<style scoped>
.produccion-page {
  padding: 1.5rem;
}

.filters-card {
  border-radius: 12px;
  border: 1px solid #e6e9ef;
  box-shadow: 0 8px 18px rgba(27, 39, 51, 0.08);
}

.filter-label {
  font-size: 0.85rem;
  color: #5a6b82;
  margin-bottom: 0.35rem;
}

.panel-card {
  border-radius: 16px;
  border: none;
  box-shadow: 0 10px 24px rgba(20, 36, 60, 0.1);
}

.panel-title {
  font-weight: 600;
  color: #1e2a3a;
  margin-bottom: 0.75rem;
}

.chart-wrap {
  height: 320px;
}

.g-1 > [class*="col"] {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.gap-1 {
  gap: 0.5rem;
}
</style>
